<template>
  <div>
    <div className="group">
      <lottie-animation
          :path="'./json/BarGraph_01.json'"
          :loop="false"
          :speed="1"
      />
    </div>
  </div>
</template>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
  components: {
    LottieAnimation,
  },
  props: {
    index: {default: 0},
  },
};
</script>

<style lang="scss" scoped>
.group {
  height: 5em;

}

// .bar {
//   border-top-left-radius: 30%;
//   border-top-right-radius: 30%;
//   margin-right: 0.2em;
//   background-color: #7fc4f2;

//   width: 0.8em;
//   &.active-bar {
//     background-color: #0089e5;
//   }
//   &.bar-0 {
//     height: 0.5em;
//     position: relative;
//     bottom: -2em;
//   }
//   &.bar-1 {
//     height: 1em;
//     position: relative;
//     bottom: -1.5em;
//   }
//   &.bar-2 {
//     height: 1.5em;
//     position: relative;
//     bottom: -1em;
//   }
//   &.bar-3 {
//     height: 2em;
//     position: relative;
//     bottom: -0.5em;
//   }
//   &.bar-4 {
//     height: 2.5em;
//   }
// }
</style>